import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import { Section, Eyebrow, H1, Lead, FadeIn } from "../components/Primitives";
import { BLOG_POSTS } from "../data/content";

export default function BlogPage() {
  const [featured, ...rest] = BLOG_POSTS;
  return (
    <div data-testid="page-blog">
      <Section className="pt-24 pb-10">
        <FadeIn><Eyebrow>The Register Journal</Eyebrow></FadeIn>
        <FadeIn delay={0.05}>
          <H1 className="mt-6 max-w-3xl">Field notes from a Paperless India.</H1>
        </FadeIn>
        <FadeIn delay={0.1}>
          <Lead className="mt-6">Stories, playbooks and product updates for teams retiring their paper registers.</Lead>
        </FadeIn>
      </Section>

      <Section className="pt-0">
        {/* Featured */}
        <Link
          to={`/blog/${featured.slug}`}
          data-testid={`blog-featured-${featured.slug}`}
          className="group block overflow-hidden rounded-3xl border border-zinc-200 bg-white"
        >
          <div className="grid lg:grid-cols-2">
            <div
              className="h-64 w-full bg-zinc-100 lg:h-full"
              style={{ backgroundImage: `url(${featured.cover})`, backgroundSize: "cover", backgroundPosition: "center" }}
            />
            <div className="flex flex-col justify-center p-8 md:p-12">
              <span className="inline-flex items-center gap-2 text-xs uppercase tracking-wider text-zinc-500">
                <Calendar className="h-3.5 w-3.5" /> {featured.date} · <Clock className="h-3.5 w-3.5" /> {featured.read}
              </span>
              <h2 className="mt-4 font-poppins text-2xl md:text-3xl font-semibold tracking-tight text-zinc-950 group-hover:underline underline-offset-4">
                {featured.title}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-zinc-600">{featured.excerpt}</p>
              <span className="mt-6 inline-flex items-center gap-1 text-sm font-medium text-zinc-950">Read article <ArrowRight className="h-4 w-4" /></span>
            </div>
          </div>
        </Link>

        {/* Grid */}
        <div className="mt-10 grid gap-6 md:grid-cols-2">
          {rest.map((p) => (
            <Link
              key={p.slug}
              to={`/blog/${p.slug}`}
              data-testid={`blog-card-${p.slug}`}
              className="group block overflow-hidden rounded-3xl border border-zinc-200 bg-white transition-all hover:-translate-y-1 hover:shadow-md"
            >
              <div
                className="h-52 w-full bg-zinc-100"
                style={{ backgroundImage: `url(${p.cover})`, backgroundSize: "cover", backgroundPosition: "center" }}
              />
              <div className="p-7">
                <span className="inline-flex items-center gap-2 text-xs uppercase tracking-wider text-zinc-500">
                  <Calendar className="h-3.5 w-3.5" /> {p.date} · <Clock className="h-3.5 w-3.5" /> {p.read}
                </span>
                <h3 className="mt-3 font-poppins text-xl font-semibold text-zinc-950 group-hover:underline underline-offset-4">{p.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-zinc-600">{p.excerpt}</p>
              </div>
            </Link>
          ))}
        </div>
      </Section>
    </div>
  );
}
